import React from 'react';
import { makeStyles } from '@mui/styles';
import { Grid, FormControl, TextField, useMediaQuery } from '@mui/material';
import propTypes from 'prop-types';

const useStyles = (small) =>
  makeStyles((theme) => ({
    formControl: {
      minWidth: 120,
    },
    addLy: {
      margin: !small && '16px',
      marginTop: small && '16px',
    },
  }));

const SearchBar = ({ setSearch, search }) => {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  return (
    <Grid container sx={{ maxWidth: '400px', alignItems: 'center' }}>
      <Grid item xs>
        <FormControl fullWidth className={classes.formControl}>
          <TextField
            variant="outlined"
            label="Filtrar por valor"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

const Props = {
  setSearch: propTypes.func,
  search: propTypes.string,
};

SearchBar.propTypes = Props;

export default SearchBar;
